import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { CSSTransition } from 'react-transition-group';
import { Avatar, Button, Col, Image, Row } from '@nackle/paper';
import { UserOutlined } from '@ant-design/icons';
import { LocaleString, getString } from '@nackle/intl-tools';
import { getSelectedPeople } from '../people/selectors';
import { getRemainingBudget, getRemainingBudgetPercent, getTotalAward } from '../awards/selectors';
import { getSelectedBehavior, getSelectedProgram } from '../program/selectors';
import { getMessage, getPrivate, getSelectedEcard } from '../message/selectors';
import BudgetMeter from '../../shared/budget-meter/BudgetMeter';
import { CheckOutlined } from '@ant-design/icons';
import { profileUrl, ecardUrl } from '../../../endpoints';

export default function Review( props ) {
    const selectedPeople = useSelector( ( state ) => getSelectedPeople( state ) );
    const remainingBudget = useSelector( ( state ) => getRemainingBudget( state ) );
    const remainingBudgetPercent = useSelector( ( state ) => getRemainingBudgetPercent( state ) );
    const totalAward = useSelector( ( state ) => getTotalAward( state ) );
    const selectedProgram = useSelector( ( state ) => getSelectedProgram( state ) );
    const selectedBehavior = useSelector( ( state ) => getSelectedBehavior( state ) );
    const message = useSelector( ( state ) => getMessage( state ) );
    const selectedEcard = useSelector( ( state ) => getSelectedEcard( state ) );
    const isPrivate = useSelector( ( state ) => getPrivate( state ) );

    const { company,
        editPage,
        forward,
        integrationType, 
        user } = props;
    const [ animate, setAnimate ] = useState( false );

    useEffect( () => {
        setAnimate( true );
    }, [] );

    return (
        <CSSTransition
            timeout={ 1000 }
            in={ animate }
            classNames={ forward ? 'slide-in' : 'slide-out' }>
            <div className='review-container'>
                <span className='input-label'><LocaleString code='recognition.review.header' /></span>
                <div className='divider'></div>
                <div className='section-container'>
                    <div className='section-header'>
                        <div>
                            { selectedPeople.length === 1
                                ? <LocaleString code='recognition.people.totalRecipient' />
                                : <LocaleString code='recognition.people.totalRecipients' replaceOptions={ { recipientCount: selectedPeople.length } } />
                            }
                        </div>
                        <div className='edit-section'>
                            <Button className="btn-edit" onClick={ () => editPage( 'people' ) }>
                                <LocaleString code='recognition.button.edit' />
                            </Button>
                        </div>
                    </div>
                    <div className='recipient-list'>
                        { selectedPeople.map( ( recipient ) => {
                            return <div key={ `recipient-award-${ recipient.id }` } className='recipient-point-row'>
                                <div>
                                    <Avatar className="primary-background-avatar" src={ `${ profileUrl }/public/images/image/${ company.id }/${ recipient.id }/avatar` } icon={ integrationType === 'WORKPLACE' ? <UserOutlined /> : null }>{ `${ recipient.givenName.slice( 0, 1 ) }${ recipient.surname.slice( 0, 1 ) }` }</Avatar>
                                </div>
                                <div className='recipient-info'>
                                    <div className='team-recipient-name'>
                                        { `${ recipient.givenName } ${ recipient.surname }` }
                                    </div>
                                    { ( recipient.department || recipient.jobTitle ) &&
                                        <div className='recipient-email'>
                                            { `${ recipient.department ? recipient.department : '' } ${ recipient.jobTitle ? recipient.jobTitle : '' }` }
                                        </div>
                                    }
                                    <div className='recipient-additionalInfo'>
                                        { `${ recipient.country }` }
                                    </div>
                                </div>
                                { selectedProgram.hasPoints &&
                                    <div className='point-entry'>
                                        { `${ recipient.awardValue } ${ getString( 'mediaLabel' ) }` }
                                    </div>
                                }
                            </div>;
                        } ) }
                    </div>
                </div>
                <div className='divider'></div>
                { ( selectedProgram.hasPoints || selectedBehavior ) &&
                    <>
                        <div className='section-container'>

                            <div className='section-header'>
                                <div>
                                    <LocaleString code='recognition.review.awardHeader' />
                                </div>
                                <div className='edit-section'>
                                    <Button className="btn-edit" onClick={ () => editPage( 'program' ) }>
                                        <LocaleString code='recognition.button.edit' />
                                    </Button>
                                </div>
                            </div>
                            { selectedProgram.hasPoints &&
                                <div className='budget-slider'>
                                    <BudgetMeter
                                        percent={ remainingBudgetPercent }
                                        current={ remainingBudget }
                                        headerText={ totalAward }
                                        additionalInfo={ selectedProgram.rewardChoiceName }
                                    />
                                </div>
                            }
                            { selectedBehavior &&
                                <div className='behavior-section'>
                                    { selectedBehavior.imageUrl &&
                                        <Avatar alt="" src={ selectedBehavior.imageUrl }></Avatar>
                                    }
                                    <div className='behavior-name'>{ selectedBehavior.name }</div>
                                </div>
                            }
                        </div>
                        <div className='divider'></div>
                    </>
                }
                <div className='section-container'>
                    <div className='section-header'>
                        <div>
                            <LocaleString code='recognition.review.personalizationHeader' />
                        </div>
                        <div className='edit-section'>
                            <Button className="btn-edit" onClick={ () => editPage( 'message' ) }>
                                <LocaleString code='recognition.button.edit' />
                            </Button>
                        </div>
                    </div>
                    <div className='personalization-container'>
                        <Row style={ { flex: 'auto' } }>
                            <Col className='message-privacy-container' span={ 16 }>
                                <div className='message-section'>
                                    { message }
                                </div>
                                { isPrivate &&
                                    <div className='privacy-section'>
                                        <CheckOutlined /> <LocaleString code='recognition.review.privateRecognition' />
                                    </div>
                                }
                            </Col>
                            { selectedEcard && selectedEcard.images &&
                                <Col span={ 8 }>
                                    <Image alt="" src={ `${ ecardUrl }/companies/${ user.claims.company_id }/ecards/${ selectedEcard.id }/locales/${ user.claims.locale }` }
                                        preview={ false } />
                                </Col>
                            }
                        </Row>
                    </div>
                </div>
                <div className='divider'></div>
            </div>
        </CSSTransition>
    );
}
